var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"frag",rawName:"v-frag"}]},[_c('v-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"absolute d-flex justify-center align-center pb-16",attrs:{"x-large":""}},[_c('h1',{staticClass:"font-weight-black grey--text text--darken-1 mb-16"},[_vm._v(" Unauthorized Access ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }